
<!---------------------------cloud service banner Starts----------->

<div id="main-wrapper">
    <div class="site-wrapper-reveal">
        <div class="position-relative w-100">
            <div class="d-flex align-items-center w-100">
                <img src="../../../assets/images/banners/cloud-newbanner.png"
                    class="img img-responsive w-100 h-100 d-none d-md-block" width="100%" alt="" />

                <img src="../../../assets/images/banners/cloud-mobile.png" class="img img-responsive d-block d-md-none"
                    width="100%" alt="" />

                <div class="position-absolute w-100 home-banner">
                    <div class="row h-100 w-100">
                        <div class="col-8 col-md-4 col-sm-6 banner-section">
                            <div class="align-items-center global_title global_banner_title title_banner_content">
                                <span>Cloud Computing Services</span>
                            </div>
                            <div class="global_sub_titles global_banner_subtitle mt-3">
                                <span>Leverage our extensive cloud expertise to remove complexities and launch your
                                    cloud with confidence.</span>
                            </div>
                            <div class="col pt-lg-3 pt-3 mt-lg-3">
                                <a href="contact" class="global_button   text-left col  text-white white_button">
                                    <div class="dub-arrow"><img src="../../../assets/images/button/arrowWhite.png"
                                            alt="" /></div>
                                    TALK WITH EXPERTS
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!---------------------------cloud service banner ends----------->

<!---------------------------Intelligence Enterprise Starts----------->
<div class="blog-section-wrapper section-space--pt_100 section-space--pb_70">
    <div class="container-fluid">
        <div class="row">
            <!-- Content Section -->
            <div class="col-lg-7 col-md-12 col-12 wow move-up">
                <div class="casestudy-mainsection" data-aos="fade-up">
                    <h2 class="reality-cloud-heading">Unlock a hyper-agile, scalable, & Intelligent enterprise reality
                        with Cloud</h2>
                    <div class="insights-subtitle global_sub_titles casestudy-subtitle my-3 my-lg-5">
                        Managing today's extensive cloud infrastructure demands modern IT operations that seamlessly
                        integrate infrastructure, data, and applications to support a resilient digital enterprise.
                        We recognize the uniqueness of each organization, which is why we meticulously analyze your
                        infrastructure to craft a customized cloud strategy that optimizes both performance and costs.
                    </div>
                    <div class="insights-subtitle global_sub_titles casestudy-subtitle my-3 my-lg-5">
                        With our expertise in Cloud Managed Services, we assist our clients in overcoming their cloud
                        challenges, simplifying complexity, and delivering solutions that enhance agility and
                        responsiveness in an ever-changing market landscape.
                        Prioritize your strategic business initiatives while entrusting us to manage your cloud
                        infrastructure so that we can deliver cloud solutions while you focus on innovation.
                    </div>
                </div>
            </div>

            <!-- Numbers Section -->
            <div class="col-lg-5 col-md-12 col-12 wow move-up">
                <div class="numbers-section mt-4">
                    <div class="row gx-2">
                        <div class="col-lg-6 col-md-6 col-6 mt-3 custom-padding">
                            <div class="number-box text-center">
                                <h1 class="number">21</h1>
                                <p class="number-description">years of experience in cloud management</p>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-6 mt-3 custom-padding">
                            <div class="number-box text-center">
                                <h1 class="number">20+</h1>
                                <p class="number-description">Certified Cloud Solutions Architects</p>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-6 mt-3 custom-padding">
                            <div class="number-box text-center">
                                <h1 class="number">50+</h1>
                                <p class="number-description">clients, ranging from startups to Fortune 500 companies</p>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-6 mt-3 custom-padding">
                            <div class="number-box text-center">
                                <h1 class="number">30%</h1>
                                <p class="number-description">reduction in IT infrastructure costs</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<!---------------------------Intelligence Enterprise End----------->

<div class="Testimonials">
    <div class="container mt-5" id="testimonials-logos">
        <div class="row" id="testimonials-logos">
            <div class="col-lg-4 col-md-4 col-sm-4 logo-container">
                <div class="logo" data-slide-to="0" data-target="#testimonial-carousel">
                    <img src="../../../assets/images/homepage/section_logos/SmartTrans.png" class="img-fluid grayscale"
                        alt="SmartTrans">
                </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 logo-container">
                <div class="logo" data-slide-to="1" data-target="#testimonial-carousel">
                    <img src="../../../assets/images/homepage/section_logos/ouropinions-logo.png"
                        class="img-fluid grayscale" alt="">
                </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 logo-container">
                <div class="logo" data-slide-to="2" data-target="#testimonial-carousel">
                    <img src="../../../assets/images/homepage/section_logos/new-movie-logo.png"
                        class="img-fluid grayscale" alt="">
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container">
    <div class="row">
        <div class="col-md-12">
            <div class="carousel-container">
                <div id="testimonial-carousel" class="carousel slide" data-ride="carousel">
                    <!-- Carousel Indicators -->
                    <!-- <ol class="carousel-indicators">
                        <li data-target="#testimonial-carousel" data-slide-to="0" class="active"></li>
                        <li data-target="#testimonial-carousel" data-slide-to="1"></li>
                        <li data-target="#testimonial-carousel" data-slide-to="2"></li>
                    </ol> -->
                    <!-- Carousel Slides -->
                    <div class="carousel-inner fixed-height-carousel">
                        <div class="carousel-item active">
                            <div class="row">
                                <div class="col-md-12 carousel-content">
                                    <!-- <h1> Futek </h1> -->
                                    <p>MIT has been managing our Azure infrastructure and related managed services for
                                        the last 5 years.
                                        They also help us in design, deployment, DevOps, root cause analysis, and
                                        optimizations on a regular basis. We are able to run our production and
                                        non-production environments without any issues so far. </p>
                                    <p class="person-name">- Cloud Technical Expert</p>
                                </div>
                            </div>
                        </div>
                        <div class="carousel-item">
                            <div class="row">
                                <div class="col-md-12 carousel-content">
                                    <!-- <h1> Our Opinions </h1> -->
                                    <p>I thank the Maganti IT team for their dedication and strategic partnership.
                                        Really appreciate the team for bringing Microsoft table. The Azure platform, as
                                        provisioned by,
                                        and the solution architecture are poised to make a significant impact on our
                                        customer service needs.</p>
                                    <p class="person-name">- Senior Director </p>
                                </div>
                            </div>
                        </div>
                        <div class="carousel-item">
                            <div class="row">
                                <div class="col-md-12 carousel-content" id="testimonial-carousels">
                                    <!-- <h1>MovieMeasure</h1> -->
                                    <p>Maganti IT built a managed services center – one that ensured infrastructure
                                        availability on a 24x7x365 basis -- to support our infrastructure on AWS.
                                        It proactively and reactively addressed and resolved our challenges by
                                        leveraging its well-defined governance structure and skilled resources across
                                        portfolios.</p>
                                    <p class="person-name">- Sr. Cloud Engineer</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Carousel Navigation Controls -->
                    <a class="carousel-control-prev" (click)="scrollToSection('#testimonial-carousel')" role="button"
                        data-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="sr-only">Previous</span>
                    </a>
                    <a class="carousel-control-next" (click)="scrollToSection('#testimonial-carousel')" role="button"
                        data-slide="next">
                        <span class="carousel-control-next-icon" ariahidden="true"></span>
                        <span class="sr-only">Next</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>

<!---------------------------Cloud Services Starts----------->

<div class="Solutions-Services" id="solution-service">
    <div class="Heading">
        <h1 style="text-align:center"> Cloud Capabilities </h1>
        <div class="insight-subtitle global_sub_title casestudy-subtitle text-center my-3 ">
            Accelerate your cloud journey with the full spectrum of infrastructure managed services including managing,
            migrating and evolving your infrastructure on-premises and in the cloud.
        </div>
    </div>

    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-3 col-sm-6 col-md-4 boxes">
                <div class="box">
                    <h1>Plan</h1>
                    <p>Identify business functionalities that benefit from cloud services. Choose a secure,
                        cost-optimized cloud to start your journey.</p>
                    <a routerLink='cloud-planning-services' href="cloud-planning-services">
                        <button class="Learn-more btn">Learn More</button>
                    </a>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-md-4 boxes ">
                <div class="box">
                    <h1>Cloud Design</h1>
                    <p>Design multi-regional, reliable, scalable, cost-optimized, secure cloud landing zones and
                        workloads.</p>
                    <a routerLink='cloud-design-services' href="cloud-design-services">
                        <button class="Learn-more btn ">Learn More</button>
                    </a>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-md-4 boxes">
                <div class="box">
                    <h1>Build</h1>
                    <p>Build a robust, scalable, and automated cloud environment for seamless workload migration or
                        deployment.</p>
                    <a routerLink='cloud-design-services' href="cloud-modernization-and-migration">
                        <button class="Learn-more btn ">Learn More</button>
                    </a>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-md-4 boxes">
                <div class="box">
                    <h1>Manage</h1>
                    <p>Get assistance in identifying and defining critical Performance Indicators for your business. We
                        support you in achieving these goals with an integrated tool stack for smooth business
                        operations.</p>
                    <a routerLink='cloud-managed-services' href="cloud-managed-services">
                        <button class="Learn-more btn ">Learn More</button>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>

<!---------------------------Cloud Services ends----------->

<div class="casestudy-layoutsection pt-lg-5" id="casestudies">
    <div class=" container-fluid p-0">
        <div class="row">
            <div class="casestudy-mainsection col-12 col-sm-12" data-aos="fade-up">
                <h1 class="Headings">Clouds We Serve</h1>
                <div class="insight-subtitle global_sub_title casestudy-subtitle my-3 ">
                    We collaborate with leading cloud providers via dedicated hyperscalar business groups to provide
                    comprehensive full-stack skills and capabilities.
                    Together, we bring together skilled teams, software, and platforms to enable secure cloud solutions
                    that drive accelerated growth for your business.
                </div>
            </div>
        </div>

        <div class=" image-grid">
            <div class="image-container">
                <img src="../../../assets/images/homepage/cloudServe-img-4.png" alt="Image 4">
            </div>
            <div class="image-container">
                <img src="../../../assets/images/homepage/cloudServe-img-1.png" alt="Image 1">
            </div>
            <div class="image-container">
                <img src="../../../assets/images/homepage/cloudServe-img-3.png" alt="Image 3">
            </div>
            <div class="image-container">
                <img src="../../../assets/images/homepage/cloudServe-img-2.png" alt="Image 2">
            </div>
        </div>
    </div>
</div>

<!------------------Carousel section starts------>
<div id="main-wrapper">
    <div class="site-wrapper-reveal">
        <div class="flexible-image-slider-wrapper">
            <div class="container-fluid p-0">
                <div class="row m-0">
                    <div class="col-lg-12 p-0">
                        <div class="flexible-image-slider-wrap">
                            <swiper-container class="single-flexible__container" slides-per-view="1" autoplay="true"
                                loop="true" navigation="true" pagination="true">
                                <swiper-slide>
                                    <!-- Single flexible slider Start -->
                                    <div class="single-flexible-slider">

                                        <img class="d-block img img-responsive w-100" alt=""
                                            src="../../../assets/images/cloud/caseStudyStory.png" />

                                        <div class="overlay-text_case-studies h-100 w-100" data-aos="fade-down">
                                            <div class="row mx-0 h-80">
                                                <div class="col-12 col-md-8 col-lg-4 px-0 h-100">
                                                    <div class="d-flex h-100 col-sm-12" id="mit-journey">
                                                        <div class="p-4 px-md-5  text-center">
                                                            <p class="text-black caseStudyTitles">
                                                                Embark on a Successful cloud journey with Maganti IT
                                                            </p>
                                                            <p class="text-black global_section_contents Download">
                                                                Discover how Maganti IT Resources can transform your
                                                                organization into a future-ready digital enterprise
                                                                with cloud.
                                                            </p>

                                                            <div class="insight-buttons text-center ">

                                                                <a href="journey-to-cloud" class="global_button">
                                                                    <div class="dub-arrow">
                                                                        <img src="../../../assets/images/aiimages/arrowBlack.png"
                                                                            alt="">
                                                                    </div>Download
                                                                </a>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <!-- Single flexible slider End -->
                                </swiper-slide>
                            </swiper-container>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!------------------Carousel section Ends------>

<div class="Use-cases">
    <div class=" container-fluid p-0">
        <div class="row">
            <div class="casestudy-mainsection col-12 col-sm-12" data-aos="fade-up">
                <h1 class="Headings">Customer Stories</h1>
                <div class="insight-subtitles global_sub_title casestudy-subtitle my-3 my-lg-5">
                    Maganti IT Resources has established relationships with some of the leading companies in the globe.
                    Together, we help clients design and realize the future of
                    their business with modern delivery methods and cloud innovation.
                </div>
            </div>
        </div>
        <button id="showImagesButton">Case Studies</button>
        <button id="showImages2Button" class="inactive-button">Use Cases</button>
        <div class="image-container case-studies-content pe-0" id="image-container1">
            <div class="container-fluid rowsizes">
                <div class="blogs-bgimage">
                    <div class="row ">
                        <!-- <div class="col-md-12 col-sm-12">
                            <div class="col-md-12 col-sm-12">
                                <div class="row justify-content-center ">
                                    <div class="row justify-content-center "> -->

                                        <div
                                            class=" blog-cardsection col-lg-4 col-md-6 col-sm-12 filter digital_marketing">
                                            <div class="card-group">
                                                <div class="insight-cards">
                                                    <img class="card-img-top"
                                                        src="../../../assets/images/homepage/CaseStudies-imd-1.png"
                                                        alt="" />
                                                    <div class="cards-body">
                                                        <h5 class="card-text global_titles pt-3 text-black">Supercharge
                                                            with Cloud & Automation
                                                        </h5>
                                                        <p class="casestudy-card-text global_section_contents pt-3">
                                                            Discover how a leading sensor technology giant transitioned
                                                            to the cloud for a significant IT transformation and
                                                            innovation.
                                                        </p>
                                                        <a href="futek-casestudy" class="read-more">Read More</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            class=" blog-cardsection col-lg-4 col-md-6 col-sm-12 filter digital_marketing">
                                            <div class="card-group">
                                                <div class="insight-cards">
                                                    <img class="card-img-top"
                                                        src="../../../assets/images/homepage/CaseStudies-imd-2.png"
                                                        alt="" />
                                                    <div class="cards-body">
                                                        <h5 class="card-text global_titles pt-3 text-black">Opinion
                                                            polling made seamless with Cloud
                                                        </h5>
                                                        <p class="casestudy-card-text global_section_contents pt-3">
                                                            Learn how we built a global website, with minimal downtime,
                                                            with future cloud advances incorporated into client's IT
                                                            infrastructure.
                                                        </p>
                                                        <a href="ouropinion-casestudy" class="read-more casestudy-read">Read More</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            class=" blog-cardsection col-lg-4 col-md-6 col-sm-12 filter digital_marketing">
                                            <div class="card-group">
                                                <div class="insight-cards">
                                                    <img class="card-img-top"
                                                        src="../../../assets/images/homepage/CaseStudies-imd-3.png"
                                                        alt="" />
                                                    <div class="cards-body">
                                                        <h5 class="card-text global_titles pt-3 text-black">
                                                            Innovation-led application services
                                                        </h5>
                                                        <p class="casestudy-card-text global_section_contents pt-3">
                                                            Learn how we built an all-in-one multi- faceted platform for
                                                            CuroRc making it faster, convenient, more secure, and less
                                                            expensive.
                                                        </p>
                                                        <a href="curorc" class="read-more">Read More</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    <!-- </div>
                                </div>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>

        </div>
        <div class="image-container use-cases-content pe-0" id="image-container2">
            <div class="container-fluid rowsizes">
                <div class="blogs-bgimage">
                    <div class="row ">
                        <!-- <div class="col-md-12 col-sm-12">
                            <div class="col-md-12 col-sm-12">
                                <div class="row justify-content-center ">
                                    <div class="row justify-content-center pt-5"> -->
                                        <div
                                            class=" blog-cardsection col-lg-4 col-md-6 col-sm-12 filter digital_marketing">
                                            <div class="card-group">
                                                <div class="insight-cards">
                                                    <img class="card-img-top"
                                                        src="../../../assets/images/homepage/UseCases-img-1.png"
                                                        alt="" />
                                                    <div class="cards-body">
                                                        <h5 class="card-text global_titles pt-3 text-black">Client
                                                            Story: Cloud optimization strategies that drove 50% cost
                                                            savings </h5>
                                                        <p class="casestudy-card-text global_section_contents pt-3">
                                                            Unlock our nine essential cloud optimization best practices,
                                                            proven to cut overspending by 20-50% </p>
                                                        <a href="cloud-cost-optimization" class="read-more">Read
                                                            More</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            class=" blog-cardsection col-lg-4 col-md-6 col-sm-12 filter digital_marketing">

                                            <div class="card-group">
                                                <div class="insight-cards">
                                                    <img class="card-img-top"
                                                        src="../../../assets/images/homepage/UseCases-img-2.png"
                                                        alt="" />
                                                    <div class="cards-body">
                                                        <h5 class="card-text global_titles pt-3 text-black">Planning
                                                            Cloud capacity for unexpected Spikes in Server Workloads
                                                        </h5>
                                                        <p class="casestudy-card-text global_section_contents pt-3">IT
                                                            teams are required to architect applications to handle
                                                            fluctuations in scale by proper capacity planning. Learn
                                                            how.</p>
                                                        <a href="cloud-cost-optimization" class="read-more">Read
                                                            More</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            class=" blog-cardsection col-lg-4 col-md-6 col-sm-12 filter digital_marketing">
                                            <div class="card-group">
                                                <div class="insight-cards">
                                                    <img class="card-img-top"
                                                        src="../../../assets/images/homepage/UseCases-img-3.png"
                                                        alt="" />
                                                    <div class="cards-body">
                                                        <h5 class="card-text global_titles pt-3 text-black">Navigating
                                                            the Maze: Hurdles in Embracing Manufacturing IT and Industry
                                                            4.0</h5>
                                                        <p class="casestudy-card-text global_section_contents pt-3">
                                                            Learn the biggest challenges faced by manufacturing clients
                                                            in technology adoption in Industry 4.0 and how Maganti IT
                                                            can be their right-sized partner of choice.</p>
                                                        <a href="challenges-manufacturing-it-industry-4-0"
                                                            class="read-more" style="top:-24px;">Read More</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    <!-- </div>
                                </div>
                                
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="insight-button text-center py-3 py-md-5">
    <a href="blogs" class="global_button global_button1">
        <div class="dub-arrow"><img src="../../../assets/images/button/arrowBlack.png" alt="" /></div>EXPLORE MORE RESOURCES 
    </a>
</div>

<div id="operations">
    <div class="row">
    </div>
    <div class="row mt-4">
        <div class="col-lg-4 col-md-4 col-sm-12 text-center mb-4">
            <img class="img-fluid" src="../../../assets/images/homepage/Independent-Perspective.png" alt="" />
            <h5>Independent Perspective</h5>
            <p>We have in-depth knowledge of the cloud vendor ecosystem and use an independent, objective
                approach in vendor selection.</p>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12 text-center mb-4">
            <img class="img-fluid" src="../../../assets/images/homepage/Business-Focus.png" alt="" />
            <h5>Business Focus</h5>
            <p>Our wide-ranging alliance ecosystem, supported by our sector and industry expertise, enables us
                to choose, integrate, and tailor cloud solutions to meet your needs.</p>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12 text-center mb-4">
            <img class="img-fluid" src="../../../assets/images/homepage/Custom-Delivery.png" alt="" />
            <h5>Custom Delivery</h5>
            <p>With our expertise in customizing delivery, we can cost-effectively support your cloud
                transformation planning, implementation, and scaling.</p>
        </div>
    </div>
</div>

<!--====================  Blog Section Start ====================-->
<div class="blog-section-wrapper section-space--pt_200" >
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-7   wow move-up">
                <div class="casestudy-mainsection col-12 col-sm-8" data-aos="fade-up">
                    <div class="casestudy_headders global_section_headers my-3 mt-lg-5 cases">Let’s discuss how
                        we can help with your cloud journey.</div>
                    <div class="insights-subtitle global_sub_titles casestudy-subtitle case-decription  my-3 my-lg-5">
                        Whether you are looking to develop a strategy, migrating to Cloud, obtain managed
                        services,
                        or further modernize and secure your applications and infrastructure, request an expert
                        consultation at no cost. 
                    </div>

                    <div class="insight-button2 text-left py-3 py-md-5">
                        <a href="contact" class="global_button">
                            <div class="dub-arrow"><img src="../../../assets/images/button/arrowBlack.png" alt="arrowBlack" />
                            </div>LET'S TALK
                        </a>
                    </div>
                </div>
            </div>

            <div class="col-lg-5   wow move-up pt-5">
                <!--======= Single Blog Item Start ========-->
                <div class="single-blog-item blog-grid">
                    <!-- Post Feature Start -->
                    <div class="post-features blog-thumbnail">
                        <a href="cloud-cost-optimization">
                            <img src="../../../assets/images/blogs/cloud-cost-optimization.png" alt="" class="w-100" />
                        </a>
                    </div>
                    <!-- Post Feature End -->
                </div>
                <!--===== Single Blog Item End =========-->
            </div>
        </div>
    </div>

</div>
<!--====================  Blog Section End  ====================-->